module.exports = __webpack_public_path__ + "static/media/plumber.0e6be738.svg";